module.exports = __webpack_public_path__ + "static/media/manufacturing3.a4161ecb.png";